import gql from 'graphql-tag';

export default gql`
	fragment complete on Builder @client {
		position
		activePage
	}
`;
